module.exports = __webpack_public_path__ + "img/servicenow.b1bb836c.svg";